import { readonly, ref } from 'vue';

const _browserStorageFingerprintProId = ref<string | null>(null);

export const browserStorageFingerprintProId = readonly(_browserStorageFingerprintProId);

export const updateBrowserStorageFingerprintProId = (id: string | null) => {
  _browserStorageFingerprintProId.value = id;
};
